import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle
} from '../BaseDialog';
import styles from './parentPortalDialog.module.scss';
import VisuallyHidden from '../../VisuallyHidden';
import ConstantContactInlineForm from '../../ConstantContactInlineForm';
import { PARENT_PORTAL_FORM_ID } from '../../ConstantContactInlineForm/constants';
import { useEffect, useState } from 'react';

type Props = {
  isOpen: boolean;
  closeDialogHandler: () => void;
  contentProps?: React.ComponentPropsWithoutRef<typeof DialogContent>;
  loading?: boolean;
  error?: string;
} & React.ComponentPropsWithoutRef<typeof Dialog>;

export default function ParentPortalDialog({
  isOpen,
  closeDialogHandler,
  contentProps,
  ...props
}: Props) {
  return (
    <Dialog {...props} open={isOpen}>
      <DialogContent
        {...contentProps}
        className={styles.content}
        onClose={closeDialogHandler}
      >
        <DialogHeader className={styles.header}>
          <img
            src="https://asthma-staging-public-storage.s3.ca-central-1.amazonaws.com/asthmaCanadaBrochureImg.svg"
            alt="Asthma Canada Brochure"
            className={styles.image}
          />
          <VisuallyHidden>
            <DialogTitle className={styles.title}></DialogTitle>
          </VisuallyHidden>

          <ConstantContactInlineForm formId={PARENT_PORTAL_FORM_ID} />
          <br />
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}
